import React, {useEffect} from 'react'
// import FontResizingButton from '../components/font-resize/font-resize';
import BackgroundImg from '../assets/images/hdb-dashboard-img.avif';
import BackgroundImgJpg from '../assets/images/hdb-dashboard-img-jpg.jpeg';
import BackgroundImgMobile from '../assets/images/hdb-dashboard-img-mobile.png';
import { P2Breadcrumb } from 'react-bootstrap-common-script';
import useIsMobile from '../hooks/use-is-mobile';
import { dashboardTrackingId } from '../utils/wogaa-ids';
import { customWindow } from '../models/interfaces/wogaa.interface';

interface ApplicationCooDashboardLayoutProps{
  children: React.ReactNode;
}
function ApplicationCooDashboardLayout({...props}:ApplicationCooDashboardLayoutProps) {
const { isMobile } = useIsMobile();

useEffect(() => {
  if (customWindow.wogaaCustom) {
    customWindow.wogaaCustom.startTransactionalService(dashboardTrackingId);
    customWindow.wogaaCustom.completeTransactionalService(dashboardTrackingId);
  }
}, []);

  return (
    <div className='polymer-application-coo-dashboard'>
      <div className='polymer-application-coo-dashboard__header'>
        <div className='polymer-application-coo-dashboard__header-banner'>
          <picture>
            {!isMobile && <>
              <source width={"auto"} height={"auto"} srcSet={BackgroundImg} type="image/avif" />
              <img width={"auto"} height={"auto"} src={BackgroundImgJpg} alt="Banner of HDB flat" />
            </>}

            {isMobile && <>
              <img width={"auto"} height={"auto"} src={BackgroundImgMobile} alt="Banner of HDB flat" />
            </>}
          </picture>  
        </div>
        <div className='polymer-application-coo-dashboard__header-actions'>
          <div className='polymer-application-coo-dashboard__breadcrumb'>
            <P2Breadcrumb
              pages={[
                { title: "Home", link: "https://www.hdb.gov.sg/" },
                { title: "Dashboard", link: "#" },
              ]}
            />
          </div>
          {/* <FontResizingButton/> */}
        </div>
        <div className='polymer-application-coo-dashboard__header-actions'>
          <div className='polymer-application-coo-dashboard__welcome-message'>
            <p className='polymer-application-coo-dashboard__welcome-message_sub-title'>Welcome to</p>
            <h1 className='polymer-application-coo-dashboard__welcome-message_title'>Change in Flat Ownership Dashboard</h1>
          </div>
          <div></div>
        </div>

      </div>
      <div className='polymer-application-coo-dashboard__card shadow-sm'>
        {props.children}
      </div>
    </div>
  )
}

export default ApplicationCooDashboardLayout